import { WebPageEvents } from '@griply/types';
import { Loading } from 'pages/loading';
import React, { Suspense } from 'react';
import { useOnboardingAnswersQuery } from 'shared/hooks/queries/use-onboarding-answers-query';
import { useUpdateOnboardingAnswersMutation } from 'shared/hooks/queries/use-update-onboarding-answers-mutation';
import { OnboardingSteps } from 'shared/types/onboarding-answers';
import { getSupportsBrowserSignIn } from 'shared/utils/get-supports-browser-sign-in';
import { DesktopSignIn } from 'shared/views/desktop-sign-in';
import { OnboardingQuestions } from 'shared/views/onboarding-questions';

import { CreateAccount } from './components/create-account';

const SignupContent: React.FC = () => {
  const { mutate: updateAnswers } = useUpdateOnboardingAnswersMutation();
  const { data: answers } = useOnboardingAnswersQuery();

  const onFinishQuestions = () =>
    updateAnswers({ lastShownStep: OnboardingSteps.CreateAccount });

  if (answers?.lastShownStep === OnboardingSteps.CreateAccount) {
    return <CreateAccount />;
  }

  return <OnboardingQuestions onFinish={onFinishQuestions} />;
};

export const Signup: React.FC = () => {
  if (getSupportsBrowserSignIn()) {
    return <DesktopSignIn pageEvent={WebPageEvents.Signup} />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <SignupContent />
    </Suspense>
  );
};
